<template>
	<div>
		<modal name="edit-unit" width="50%" height="auto" draggable=".modal-header">
	        <div class="w-full flex flex-col">
	            <div class="modal-header flex items-center justify-between cursor-move">
	                <h1 class="flex-1 text-2xl">{{ unit.id ? 'Edit Unit' : 'New Unit' }}</h1>
	                <div @click="hideEditUnit">
	                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
	                </div>
	            </div>
		        <form class="p-6 divide-y divide-gray-200">
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="floor">Floor</label>
				    	</div>
				    	<div class="flex-1">
							<select name="floor" v-model="unit.floor" class="mt-0 form-select max-w-fit">
								<option value=""></option>
								<option v-for="floor in floors" :key="floor" :value="floor">{{ floor }}</option>
							</select>
							<div v-if="errors.floor" class="form-error">{{ errors.floor[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="suite">Suite</label>
				    	</div>
				    	<div class="flex-1">
							<input type="text" class="form-input" name="suite" size="6" v-model="unit.suite">
							<div v-if="errors.suite" class="form-error">{{ errors.suite[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="size">Size</label>
				    	</div>
				    	<div class="flex-1">
				    		<number-input name="size" v-model="unit.size" classes="text-sm text-right"></number-input>
							<div v-if="errors.size" class="form-error">{{ errors.size[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="divisble">Divisible</label>
				    	</div>
				    	<div class="flex-1">
				    		<number-input name="divisible" v-model="unit.divisible" classes="text-sm text-right"></number-input>
							<div v-if="errors.divisible" class="form-error">{{ errors.divisible[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="description">Status</label>
				    	</div>
				    	<div class="flex-1">
				    		<div>
								<select class="mt-0 form-select flex-none max-w-fit" name="status" v-model="unit.status">
									<option value=""></option>
									<option value="Available">Available</option>
									<option value="Occupied">Occupied</option>
									<option value="Sublease">Sublease</option>
									<option value="Vacant">Vacant</option>
								</select>
								<div v-if="errors.status" class="form-error">{{ errors.status[0] }}</div>
							</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="flex flex-col w-1/3">
				    		<label class="text-base">Renewal Space?</label>
				    	</div>
				    	<div class="flex-1">
						    <toggle-button v-model="unit.is_renewal_space" color="#38C172" sync></toggle-button>
						    <div v-if="errors.is_renewal_space" class="form-error">{{ errors.is_renewal_space[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="ti_allowance">TI Allowance</label>
				    	</div>
				    	<div class="flex-1">
				    		<currency-input name="ti_allowance" v-model="ti_allowance" is-decimal></currency-input>
							<div v-if="errors.ti_allowance" class="form-error">{{ errors.ti_allowance[0] }}</div>
				    	</div>
				    </div>
			    	<div class="flex py-4">
			    		<div class="w-1/3">
				    		<label class="text-base" for="description">Comments</label>
				    	</div>
				    	<div class="flex-1">
							<textarea class="form-textarea" name="comment" rows="5" cols="50" v-model="unit.comment" :v-text="unit.comment"></textarea>
							<div v-if="errors.comment" class="form-error">{{ errors.comment[0] }}</div>
				    	</div>
				    </div>
		        </form>
	            <div class="bg-gray-100 p-4">
	                <div class="text-right">
						<button class="btn btn-secondary mr-2" @click.prevent="hideEditUnit">Close</button>
						<button class="btn btn-green" @click.prevent="save">Save Unit</button>
	                </div>
	            </div>
			</div>
		</modal>
		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

    export default {
        props: {
        	unitId: {
        		type: [Number, String],
        		required: true
        	},

        	buildingData: {
        		type: Object,
        		required: true
        	}
        },

        data() {
            return {
            	unit: {},
            	building: this.buildingData,
            	ti_allowance: '',
            	errors: [],
            }
        },

        mounted() {
    		if (this.unitId == "") {
    			this.unit = {};

    			this.ti_allowance = '';
    		} else {
    			this.unit = {};
        		this.unit = _.clone(_.find(this.units.all, (unit) => unit.id == this.unitId));
        		this.ti_allowance = this.ti;
    		}
        },

        watch: {
        	unitId() {
        		if (this.unitId == "") {
        			this.unit = {};

        			this.ti_allowance = '';
        		} else {
        			this.unit = {};
	        		this.unit = _.clone(_.find(this.units.all, (unit) => unit.id == this.unitId));
	        		this.ti_allowance = this.ti;
        		}
        	}
        },

        computed: {
        	...mapState(['units']),

        	ti: {
        		get() {
	        		return this.formatCurrency(this.unit.ti_allowance, 2);   			
        		},

        		set(newValue) {
        			this.ti_allowance = newValue;
        		}
        	},

        	floors() {
        		return this.building.floors || 1;
        	}
        },

        methods: {
            hideEditUnit() {
                this.$modal.hide('edit-unit');
            },

            save() {
            	this.errors = [];

            	this.unit.ti_allowance = this.prepCurrency(this.ti_allowance);

            	if (typeof this.unit.id == "undefined") {
            		this.createUnit();
            	} else {
            		this.updateUnit();
            	}
            },

            createUnit() {
            	this.unit.building_id = this.building.id;

				axios.post('/units', this.unit)
	                .then((response) => {
						this.$notify({
							type: 'success',
							title: 'Success',
							text: response.data.message
						});

						this.$emit('unit-updated', {
							'building': response.data.building,
							'unit': response.data.unit
						});

						this.hideEditUnit();
	                })
	                .catch((error) => {
	                	console.log(error);
						this.errors = error.response.data.errors;
	                }
				);
            },

            updateUnit() {
				axios.patch('/units/' + this.unit.id, this.unit)
	                .then((response) => {
						this.$notify({
							type: 'success',
							title: 'Success',
							text: response.data.message
						});

						this.$emit('unit-updated', {
							'building': response.data.building,
							'unit': response.data.unit
						});

						this.hideEditUnit();

						// setTimeout(() => {
						// 	window.location = '/buildings/' + this.unit.building_id;				
						// }, 1000);
	                })
	                .catch((error) => {
	                	console.log(error);
						this.errors = error.response.data.errors;
	                }
				);
            },
        }
    }
</script>